(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('PainelMaquinasCtrl', PainelMaquinasController);

  PainelMaquinasController.$inject = [
    '$scope',
    '$routeParams',
    '$location',
    'LoadingService',
    'TrackingService',
    'MessagesService',
    'MapaService',
    '$rootScope'
  ];

  // eslint-disable-next-line max-params, max-lines-per-function
  function PainelMaquinasController($scope, $routeParams, $location,
    LoadingService, TrackingService, MessagesService,
    MapaService, $rootScope) {
    const vm = this;
    let willChangePropriedade = false;

    //////////////////////////////////////////
    // Controller data
    vm.maquinas = [];
    vm.search = '';
    vm.selections = $routeParams.selections ? JSON.parse(atob($routeParams.selections)) : {};
    vm.loading = false;

    //////////////////////////////////////////
    // Bindable functions
    vm.expandMaquina = expandMaquina;
    vm.showTracking = showTracking;
    vm.refresh = refresh;
    vm.isRecent = isRecent;

    //////////////////////////////////////////
    // Function declarations

    function loadMaquinas() {
      vm.loading = true;
      return TrackingService.lastSendingMaquinas()
        .then(({ data }) => {
          vm.maquinas = (data || []).map((maquina) => {
            maquina.open = maquina.maquina_id in vm.selections;
            return maquina;
          });
        })
        .catch((error) => {
          console.error(error);
          MessagesService.alert('Não foi possível buscar a lista de máquinas.');
        })
        .finally(() => {
          vm.loading = false;
        });
    }

    function expandMaquina(event, maquina) {
      event.stopPropagation();
      event.preventDefault();
      const selections = angular.copy(vm.selections);
      if (maquina.maquina_id in selections) {
        delete selections[maquina.maquina_id];
      } else {
        selections[maquina.maquina_id] = [];
      }
      updateRoute(selections);
    }

    function loadMaquinaGlebas(maquina) {
      if (!maquina.glebas) {
        maquina.glebas = [];
        const filters = {
          data: maquina.ultimo_envio,
          maquina: maquina.maquina_id
        };

        LoadingService.showLoading();
        return TrackingService.getGlebasVisitadas(filters).then(({ data }) => {
          maquina.glebas = data || [];
          maquina.glebas.map((gleba) => {
            gleba.selected = maquina.open && vm.selections[maquina.maquina_id].includes(gleba.gleba.id);
            if (gleba.selected) {
              loadGlebaTrackings(maquina, gleba);
            }
            return gleba;
          });
          return maquina.glebas;
        })
          .finally(LoadingService.hideLoading);
      }
    }

    function showTracking(maquina, gleba) {
      const selections = angular.copy(vm.selections);
      if (gleba.selected) {
        selections[maquina.maquina_id].splice(selections[maquina.maquina_id].indexOf(gleba.gleba.id), 1);
      } else {
        selections[maquina.maquina_id].push(gleba.gleba.id);
      }
      updateRoute(selections);
    }

    function loadGlebaTrackings(maquina, gleba) {
      if (checkPropriedade(gleba, maquina)) {
        const filters = {
          maquina: maquina.maquina_id,
          gleba: gleba.gleba,
          dia: moment(maquina.ultimo_envio).format('Y-MM-DD')
        };
        LoadingService.showLoading();
        gleba.loading = true;
        TrackingService.list(filters)
          .then(({ data }) => {
            if (data.length < 4) {
              showTracking(maquina, gleba); // desativa gleba
              return MessagesService.alert('Pontos insuficientes para desenhar o caminhamento.');
            }
            return makeGlebaTrackings(gleba, data);
          })
          .catch((error) => {
            console.error(error);
            MessagesService.alert('Falha ao recuperar caminhamento.');
          })
          .finally(() => {
            LoadingService.hideLoading();
            gleba.loading = false;
          });
      }
    }

    function checkPropriedade(gleba, maquina) {
      if ($rootScope.currentPropriedade.id !== +gleba.propriedade.id) {
        const propriedade = _.find($rootScope.propriedades, { id: +gleba.propriedade.id });
        if (!propriedade) {
          showTracking(maquina, gleba); // desativa gleba
          return MessagesService.alert(`
            Falha ao carregar dados, verifique se você possui
            permissão para visualizar dados da propriedade ${gleba.propriedade.descricao}.
          `);
        }
        // Tira da seleção as glebas marcadas que não estão presentes na nova propriedade
        const selections = {
          [maquina.maquina_id]: [gleba.gleba.id]
        };
        $location.search('propriedade', propriedade.id);
        $location.search('selections', btoa(JSON.stringify(selections)));
        willChangePropriedade = true;
        $rootScope.setPropriedade(propriedade);
        return false;
      }
      return true;
    }

    function makeGlebaTrackings(gleba, trackings) {
      gleba.trackings = MapaService.getLeafletPolylineWithObject({
        pontos: trackings
      }).map((tracking) => {
        const polyline = createDecoratedPolyline(tracking);
        polyline.bindPopup(createInfoWindow(polyline), {
          className: 'leaflet-default-popup'
        });
        return polyline;
      });
      const start = gleba.trackings[0].getLatLngs();
      const end = gleba.trackings.slice(-1)[0].getLatLngs();
      gleba.startEndMarkers = MapaService.createStartEndMarkers({
        latitude: start[0].lat,
        longitude: start[0].lng
      }, {
        latitude: end[0].lat,
        longitude: end[0].lng
      });
      if (gleba.selected) {
        renderTrackings();
      }
      return gleba;
    }

    function createDecoratedPolyline(polyline) {
      const decorator = L.polylineDecorator(polyline, {
        patterns: [
          {
            offset: 10,
            repeat: 25,
            symbol: L.Symbol.arrowHead({
              pixelSize: 7,
              polygon: false,
              pathOptions: {
                stroke: true
              }
            })
          }
        ]
      });
      polyline.decorator = decorator;
      return polyline;
    }

    function createInfoWindow(polyline) {
      return TrackingService.getContentInfoWindow(polyline);
    }

    function renderTrackings() {
      if (!willChangePropriedade) {
        const resources = vm.maquinas.reduce((res, maquina) => {
          if (maquina.open) {
            maquina.glebas.forEach((gleba) => {
              if (gleba.selected && gleba.trackings) {
                res.trackings = res.trackings.concat(gleba.trackings);
                res.markers = res.markers.concat(gleba.startEndMarkers);
              }
            });
          }
          return res;
        }, {
          trackings: [],
          markers: []
        });
        $scope.$emit('setPolylines', resources.trackings);
        $scope.$emit('setMarkers', resources.markers.map((m) => ({
          leafletMarker: m
        })));
      }
    }

    function updateRoute(selections) {
      selections = btoa(JSON.stringify(selections || {}));
      $location.search('selections', selections);
    }

    function answerToRouteUpdates() {
      vm.maquinas.forEach((maquina) => {
        maquina.open = maquina.maquina_id in vm.selections;

        if (maquina.open && !maquina.glebas) {
          return loadMaquinaGlebas(maquina);
        }

        if (!maquina.open) {
          delete maquina.glebas;
        }

        (maquina.glebas || []).forEach((gleba) => {
          gleba.selected = maquina.open && vm.selections[maquina.maquina_id].includes(gleba.gleba.id);
          if (gleba.selected && !gleba.trackings) {
            return loadGlebaTrackings(maquina, gleba);
          }
        });
      });
      renderTrackings();
    }

    function refresh() {
      updateRoute({});
      vm.maquinas = [];
      loadMaquinas();
    }

    function isRecent(maquina) {
      return moment().isSame(maquina.ultimo_envio, 'day');
    }

    //////////////////////////////////////////
    // Controller logic

    $scope.$root.initialize
      .then(() => {
        if (!$scope.$root.permissions.painelUsuario.canRead) {
          MessagesService.alert(ACESSO_NAO_PERMITIDO.msg);
          $location.search('sidebar', null);
          throw new Error('stop loading');
        }
        return loadMaquinas();
      })
      .then(() => answerToRouteUpdates())
      .catch((error) => {
        if (error.message !== 'stop loading') {
          console.error(error);
          MessagesService.alert('Erro ao carregar máquinas');
        }
      });

    $scope.$on('$routeUpdate', () => {
      if ($routeParams.selections) {
        vm.selections = JSON.parse(atob($routeParams.selections));
      } else {
        vm.selections = {};
      }
      answerToRouteUpdates();
    });

    $scope.$on('$destroy', () => {
      $scope.$emit('clearPolylines');
      $scope.$emit('setMarkers', []);
      if (!willChangePropriedade) {
        $location.search('selections', null);
      }
    });
  }
}());
